import Worker from 'workerize-loader!./worker'; // eslint-disable-line import/no-webpack-loader-syntax, import/no-unresolved

export const makePDF = (type, data) => {
  let worker;

  return new Promise((resolve, reject) => {
    worker = new Worker();
    worker.addEventListener('message', (message) => {
      const { err, success } = message.data;

      if (success === undefined) return;

      return success ? resolve(message.data.data) : reject(err);
    });

    worker.makePDF({ type, data });
  }).finally(() => worker.terminate());
};
